const step_up = {
    verify_your_identity: 'هویت خود را تأیید کنید',
    choose_method_description: 'برای ادامه، هویت خود را با یکی از روش‌های زیر تأیید کنید.',
    password: 'رمز عبور',
    password_description: 'رمز عبور حساب خود را وارد کنید',
    enter_password_description: 'برای ادامه، رمز عبور حساب خود را وارد کنید.',
    enter_verification_code_description: 'کد تأیید ارسال‌شده به {{identifier}} را وارد کنید.',
    subject_proof_description: 'برای ادامه، هویت خود را از طریق حسابی که به حساب شما متصل است تأیید کنید. سپس می‌توانید یک روش تأیید تنظیم کنید.',
    subject_mismatch: 'حساب مطابقت ندارد',
    subject_mismatch_description: 'حسابی که استفاده کردید به حساب شما متصل نیست. از یک حساب متصل استفاده کنید و در صورت نیاز، حساب را در سرویس‌دهنده تغییر دهید.',
    no_method_available: 'هیچ روش تأییدی در دسترس نیست',
    no_method_available_description: 'حساب شما هیچ روشی ندارد که بتواند این تأیید را انجام دهد. لطفاً برای دریافت کمک با مدیر خود تماس بگیرید.',
};
export default Object.freeze(step_up);
